import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { dictionary } from '../../../lang';
import { mergeClassNames } from '../../../utils';
import TeamPanelRow from './TeamPanelRow';
/**
 * @param {import('../../../redux').TeamRepDetails} rep
 * @param {Array<number>} selectedReps
 * @param {(selectedRepId: number) => void} onRepClick
 */
const TeamRepPanel = ({ rep, selectedReps, onRepClick, }) => {
    const [isSelected, setIsSelected] = useState(false);
    const onClick = () => {
        onRepClick(rep.id);
    };
    useEffect(() => {
        setIsSelected(selectedReps.includes(rep.id));
    }, [rep.id, selectedReps]);
    return (_jsx("div", { className: "border-x p-1", onClick: onClick, onTouchStart: onClick, children: _jsx("div", { className: mergeClassNames('flow-root hover:cursor-pointer rounded', isSelected ? 'bg-blue-50' : ''), children: _jsxs("div", { className: "px-3 py-2", children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsx("div", { className: "text-sm fs-exclude", children: rep.name }), _jsx("div", { className: "text-xs text-blue-500 fs-exclude", children: isSelected ? 'Deselect' : 'Select' })] }), _jsxs("div", { className: "text-[0.65rem] pt-2", children: [_jsx(TeamPanelRow, { label: dictionary.ASSIGNED_POLYGONS, value: rep.assignedPolygons }), _jsx(TeamPanelRow, { label: dictionary.CURRENT_PINS, value: rep.qualifiedAddresses })] })] }) }) }));
};
TeamRepPanel.propTypes = {
    rep: PropTypes.object,
    selectedReps: PropTypes.array,
    onRepClick: PropTypes.func,
};
export default TeamRepPanel;
